import { useComputed } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'

const NewProfileModal = function ({ showSignal, newProfileNameSignal, newProfileUtgVersionSignal, nameAlreadyUsedComputed, profileSchemaVersionsComputed, handleSubmit }) {

    const handleCloseModal = () => {
        showSignal.value = false
    }

    const disableSubmitComputed = useComputed(() => {
        return (newProfileNameSignal.value?.length == 0 || newProfileUtgVersionSignal.value?.length == 0 || nameAlreadyUsedComputed.value)
    })

    return (
        <Modal show={showSignal.value} onHide={handleCloseModal}>
            <Modal.Header closeButton>
                <Modal.Title>Add a New Profile</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                        <Form.Label>Profile Name</Form.Label>
                        <Form.Control
                            type="text"
                            required
                            onInput={(e) => newProfileNameSignal.value = e.target.value}
                            autoFocus
                            value={newProfileNameSignal.value}
                        />
                        <p className="mt-1" hidden={!nameAlreadyUsedComputed.value}>Profile name must be unique</p>
                    </Form.Group>
                    <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1"
                    >
                        <Form.Label>UTG Version</Form.Label>
                        <Form.Select aria-label="Utg Version Profile Schema"
                            required
                            value={newProfileUtgVersionSignal.value}
                            onChange={(e) => newProfileUtgVersionSignal.value = e.target.value}>
                            {profileSchemaVersionsComputed.value.map(v => <option key={v} value={v}>{v}</option>)}
                        </Form.Select>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseModal}>
                    Cancel
                </Button>
                <Button disabled={disableSubmitComputed.value} variant="primary" onClick={handleSubmit}>
                    Add New
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default NewProfileModal